export default __webpack_public_path__ + "static/TTCommons-Medium-023095ebd8f37bee4e6d19d233270404.woff2";